<template>
  <div class="common_form_item">
    <div class="common_form_item_label">
      <img v-if="required" class="required" src="@/assets/basicLevel/required_star.svg" alt="" />
      <div class="label">{{ label }}</div>
      <div v-if="note" class="note">{{ note }}</div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'CommonFormItem',
  props: {
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    note: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.common_form_item {
  width: 100%;
}

.common_form_item_label {
  width: 100%;
  padding: 0 0.16rem;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.12rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.2rem;
  display: flex;
  align-items: center;
  margin-bottom: 0.02rem;
}

.required {
  width: 0.08rem;
  height: 0.08rem;
  margin-inline-end: 0.08rem;
  flex-shrink: 0;
}

.label {
  flex-shrink: 0;
}

.note {
  color: #ff4c62;
  font-family: 'PingFang SC';
  font-size: 0.1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.14rem;
  margin-inline-start: 0.08rem;
  flex: 1;
  min-width: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/CommonFormItem.vue